import type { ReactElement } from 'react';
import { AdditionalNotes } from './AdditionalNotes';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/additional-notes': <AdditionalNotes />,
};
